import { render, staticRenderFns } from "./SmartLabel.vue?vue&type=template&id=159f8104&scoped=true&"
import script from "./SmartLabel.vue?vue&type=script&lang=js&"
export * from "./SmartLabel.vue?vue&type=script&lang=js&"
import style0 from "./SmartLabel.vue?vue&type=style&index=0&id=159f8104&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159f8104",
  null
  
)

export default component.exports